import styled from 'styled-components';
import { Menu, Icon } from 'antd';

export const NavContainer = styled.div`
  height: 80px;

  position: fixed;
  background: white;
  top:40px;
  z-index:999;
  width: 100%;
  .ant-menu-horizontal{
    border-bottom: none
  }
  @media only screen and (max-width: 1024px) and (min-width: 900px) {
    padding: 0 10px 0 20px;
  }
`
export const AssistanceContainer = styled.div`
  display: none;
  @media only screen and (max-width: 991.92px) {
    padding-left: 24px;
    cursor: pointer;
    display: block;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.border.inputBox};
  }
`;
export const DisplayFlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  
  @media only screen and (max-width: 576px) {
    padding-top: 4px;
  }
`
export const MainContainer = styled.div`
  display: flex;
  .ant-menu-horizontal{
    border-bottom: none
   
  }
`
export const HamBurger = styled.div`
  display: none;
  @media only screen and (max-width: 991.92px) {
    flex-basis: 80%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 6px;
  }
`

export const ImageContainer = styled.div`
  padding-top: 6px;
`

export const NavMenu = styled(Menu)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  font-size: ${ props => props.theme.fontSize.secondary};
  font-weight: ${ props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: condensed;
  letter-spacing: 0.5px;
  line-height: 74px;
  margin-right: -20px;
  .ant-menu-item > a, .ant-menu-submenu-title{
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-weight: ${ props => props.theme.fontWeight.normal}!important;
    color: ${ props => props.theme.fontColors.headingColor} !important;
    text-transform: capitalize;
  }
  @media only screen and (max-width: 1090px) {
    .ant-menu-item, .ant-menu-submenu-title {
      padding: 0px 10px
    }
  }
  @media only screen and (max-width: 991.92px) {
    display: none
  }
`;

export const NavSubMenu = styled(Menu.SubMenu)`
  .ant-menu-item {
    padding: 0;
  }
  .ant-menu-item a {
    padding: 0 16px;
    pointer-events: all;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  }
  .ant-menu-item > a:hover, .ant-menu-item > a{
    color:${props => props.theme.fontColors.headingColor} !important;
    font-size:14px !important;
    font-weight: normal;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};     
  }
  &.coloring{
    background:#fff1d0;
    .ant-menu-submenu-title{
      padding: 0px 10px;
    }
  }
`;


export const NavInline = styled(Menu)`
font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
font-weight: ${ props => props.theme.fontWeight.normal};
  font-size: ${ props => props.theme.fontSize.secondary};
  font-style: normal;
  font-stretch: condensed;
  letter-spacing: 0.5px;
  line-height: 77px;
  margin-top: 22px;
  display: none;
  border: none;
  height: calc(100vh - 120px);
  overflow-y : scroll;
  overflow-x : hidden;
  padding-top: 15px;
  @media only screen and (max-width:991px) and (min-width:577px){
    /* added for hidden navigation fields in mobile view */
    margin-top: 66px !important;
  }
  @media only screen and (min-width: 900px) and (max-width:991px){
    position:absolute;
    left:0;
    right:0;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected{
    background-color: #f2f2f2;
  }
  .ant-menu-item-selected {
    color: ${ props => props.theme.fontColors.headingColor};

  }
  z-index: 999;
  @media only screen and (max-width: 991.92px) {
    display: ${ props => props.isOpen === true ? 'block' : 'none'};
  }
`;

export const CaretIcon = styled(Icon)`
  padding-left: 5px;
  margin-right: 0px !important;
  @media only screen and (max-width: 991.92px) {
    display: ${ props => props.mode === 'horizontal' ? 'inherit' : 'none'};
  }
`;

export const NavMenuItem = styled(Menu.Item)`
  &.ant-menu-item-disabled a {
    pointer-events: all;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  }
&&&{
    .ant-menu-item-selected > a{
      color:green;
    }
    text-transform: capitalize;

  }
`;


export const NavMenuItem123 = styled.a`
    text-decoration: none;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    text-transform: capitalize;
    color: ${ props => props.theme.fontColors.headingColor};
    :hover,:active,:focus{
      color: ${ props => props.theme.fontColors.headingColor};
    }
  
`;




export const NavSubMenuItem = styled(Menu.SubMenu)`
  .ant-menu-inline .ant-menu-submenu-title {
    @media only screen and (max-width: 720px) {
      overflow: inherit;
    }
  }
  .ant-menu-submenu-title {
    @media only screen and (max-width: 720px) {
      padding-right: 20px;
      overflow: inherit;
    }
  }
  .ant-menu-item-selected {
   color: ${ props => props.theme.fontColors.headingColor};
  }
  &&&{
    color: ${ props => props.theme.colors.primary};
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-weight: ${ props => props.theme.fontWeight.normal};
  }
  & a {
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-weight: normal;
  }
  &:not(.ant-menu-submenu-open) a{
    @media only screen and (max-width: 720px){
      display: inline-block;
      width: 100%;
      border-bottom: 1px solid ${props => props.theme.colors.primaryColor};
      height: 45px;
      padding-top: 3px;
    }
  }
`;

export const Img = styled.img`
  width: 143px;
  height: 60px;
  @media only screen and (max-width: 576px) {
    width: 120px;
    height: 48px;
  }
`;



// New Header Menu Items

export const MainPagesNavigation = styled(Menu.Item)`
  
`;
